<div class="config-div">
    <!-- Select report type. -->
    <mat-form-field class="report-type-mat-form-field">
        <mat-label class="mat-label">Report</mat-label>

        <mat-select [(ngModel)]="this.SelectedReportTypeId"
                    (selectionChange)="this.onReportTypeSelectionChanged($event)">
            <mat-option [value]="0">** Select a Report **</mat-option>

            <mat-option *ngFor="let report of this.ReportTypes"
                        [value]="report.reportId">
                {{report.reportType}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- Display conditional select fields for selecting a workflow, a magic folder, or a magic form instance. -->
    <ng-container *ngIf="this.ShowSiteWorkflows">
        <mat-form-field class="workflow-mat-form-field">
            <mat-label class="mat-label">Workflow</mat-label>

            <mat-select [(ngModel)]="this.SelectedWorkflowId"
                        (selectionChange)="this.onWorkflowSelectionChanged($event)">
                <mat-option [value]="0">** Select a workflow **</mat-option>

                <mat-option *ngFor="let workflow of this.SiteWorkflows"
                            [value]="workflow.id">
                    {{workflow.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>
    <ng-container *ngIf="this.ShowMagicFolders">
        <mat-form-field class="magic-structure-mat-form-field">
            <mat-label class="mat-label">Magic Folders</mat-label>

            <mat-select [(ngModel)]="this.SelectedMagicFolderId"
                        (selectionChange)="this.onMagicFolderSelectionChanged($event)">
                <mat-option [value]="0">** Select a magic folder **</mat-option>

                <mat-option *ngFor="let folder of this.MagicFolders"
                            [value]="folder.id">
                    {{folder.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>
    <ng-container *ngIf="this.ShowMagicFormInstances">
        <mat-form-field class="magic-structure-mat-form-field">
            <mat-label class="mat-label">Magic Forms</mat-label>

            <mat-select [(ngModel)]="this.SelectedMagicFormInstanceId"
                        (selectionChange)="this.onMagicFormInstanceSelectionChanged($event)">
                <mat-option [value]="0">** Select a magic form **</mat-option>

                <mat-option *ngFor="let formInstance of this.MagicFormInstances"
                            [value]="formInstance.id">
                    {{formInstance.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>

    <!-- Select chart type (will probably remove this). -->
    <ng-container *ngIf="false">
        <mat-form-field class="chart-type-mat-form-field">
            <mat-label class="mat-label">Chart Type</mat-label>

            <mat-select [(ngModel)]="this.SelectedChartId"
                        (selectionChange)="this.onChartTypeSelectionChanged($event)">
                <mat-option [value]="0">** Select Chart Type **</mat-option>

                <mat-option *ngFor="let chartType of this.ChartTypes"
                            [value]="chartType.chartId">
                    {{chartType.chartType}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>
</div>
